import React from 'react';
import { FormAccordion, FormAccordionItem } from 'src/UI/dynamicUI/layout/DynamicEntitySection';
import { Grid } from '@mantine/core';
import { ProductFormComponentProps } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormHelpers';
import { GridPair } from 'src/financial/financial-data/financial-item/forms/common/GridPair';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';
import { GenericFinancialItemFormWrapper } from 'src/financial/financial-data/financial-item/forms/GenericFinancialItemFormWrapper';
import styles from 'src/financial/financial-data/financial-item/forms/common/FormLayout.module.css';

const SPENDING_ACCOUNT_PRODUCT = 'SpendingAccount';

export function SpendingAccount(props: ProductFormComponentProps) {
  return (
    <GenericFinancialItemFormWrapper
      title={'Spending account'}
      {...props}
      product={SPENDING_ACCOUNT_PRODUCT}
    >
      <FormAccordion defaultValue={['summary', 'balance', 'additional']}>
        <FormAccordionItem value="summary" label="Summary">
          <Grid>
            <GridPair
              first={<FinancialFormField field="type" product={SPENDING_ACCOUNT_PRODUCT} />}
              second={<FinancialFormField field="description" product={SPENDING_ACCOUNT_PRODUCT} />}
            />
            <GridPair
              first={<FinancialFormField field="provider" product={SPENDING_ACCOUNT_PRODUCT} />}
            />
          </Grid>
          <Grid className={styles.highlightedGrid}>
            <GridPair
              first={<FinancialFormField field="account_name" product={SPENDING_ACCOUNT_PRODUCT} />}
              second={
                <FinancialFormField field="account_reference" product={SPENDING_ACCOUNT_PRODUCT} />
              }
            />

            <GridPair
              first={
                <FinancialFormField
                  field="account_holder_name"
                  product={SPENDING_ACCOUNT_PRODUCT}
                />
              }
            />
          </Grid>
          <Grid>
            <GridPair
              first={<FinancialFormField field="is_joint" product={SPENDING_ACCOUNT_PRODUCT} />}
            />
          </Grid>
        </FormAccordionItem>
        <FormAccordionItem value="balance" label="Valuation">
          <Grid className={styles.highlightedGrid}>
            <GridPair
              first={
                <FinancialFormField field="current_balance" product={SPENDING_ACCOUNT_PRODUCT} />
              }
              second={
                <FinancialFormField field="balance_date" product={SPENDING_ACCOUNT_PRODUCT} />
              }
            />
          </Grid>
        </FormAccordionItem>
        <FormAccordionItem value="additional" label="Additional information">
          <Grid>
            <GridPair
              first={
                <FinancialFormField
                  field="withdrawal_notice_in_days"
                  product={SPENDING_ACCOUNT_PRODUCT}
                />
              }
              second={
                <FinancialFormField field="interest_rate" product={SPENDING_ACCOUNT_PRODUCT} />
              }
            />
            <GridPair
              first={
                <FinancialFormField field="overdraft_limit" product={SPENDING_ACCOUNT_PRODUCT} />
              }
              second={
                <FinancialFormField label="AER" field="aer" product={SPENDING_ACCOUNT_PRODUCT} />
              }
            />
          </Grid>
        </FormAccordionItem>
      </FormAccordion>
    </GenericFinancialItemFormWrapper>
  );
}
